/**
 * First Sale Tracker - Step Configuration
 *
 * Defines the 8 sequential steps with descriptions and optional internal links.
 * This configuration is frontend-only — step definitions (key, number) are seeded
 * in the database, but descriptions and resources live here for easy content management.
 *
 * Each step object:
 *   label        {string}  - Display title for the step
 *   description  {string}  - Motivational copy explaining the step
 *   internalLink {string=} - Optional route path for an in-app navigation link
 */

export const STEP_CONFIG = {
  make_first_call: {
    label: 'Make First Call',
    description: 'Pick up the phone and make your first outbound call to a prospect.',
    contentSlug: 'fst-step-make-first-call',
  },
  sustain_2min_call: {
    label: 'Sustain 2-Minute Call',
    description: 'Complete a phone conversation exceeding 2 minutes. Build rapport!',
    contentSlug: 'fst-step-sustain-2min-call',
  },
  first_fact_finder: {
    label: 'First Fact Finder',
    description: 'Conduct a needs analysis call where the client shares their insurance needs using the worksheet.',
    contentSlug: 'fst-step-first-fact-finder',
  },
  build_sales_proposal: {
    label: 'Build Sales Proposal',
    description: 'Research customer needs and carrier offerings, then build a tailored proposal plan.',
    contentSlug: 'fst-step-build-sales-proposal',
  },
  fulfill_first_appt: {
    label: 'Fulfill First Appointment',
    description: 'Virtually meet with your client to present your initial proposal.',
    contentSlug: 'fst-step-fulfill-first-appt',
  },
  close_first_deal: {
    label: 'Close First Deal',
    description: 'Get customer acceptance and have them complete all requirements.',
    contentSlug: 'fst-step-close-first-deal',
  },
  submit_to_carrier: {
    label: 'Submit to Carrier',
    description: 'Provide customer info, billing details, and policy information to the health insurance carrier.',
    contentSlug: 'fst-step-submit-to-carrier',
  },
  submit_to_sales_tracker: {
    label: 'Submit to Sales Tracker',
    description: 'Complete the sales submission form in the backoffice for the sales competition.',
    contentSlug: 'fst-step-submit-to-sales-tracker',
    internalLink: '/submit-sales',
  },
}

/** Total number of steps in the tracker. */
export const TOTAL_STEPS = Object.keys(STEP_CONFIG).length

/** All agency_content slugs for batch fetch on page mount. */
export const STEP_CONTENT_SLUGS = Object.values(STEP_CONFIG).map(c => c.contentSlug)

/** Character limit for step notes. */
export const NOTES_MAX_LENGTH = 500
